import React from 'react';
import PropTypes from 'prop-types';
import { Ratio, RatioContent } from './styled';

const FixedRatio = ({value, children}) => {
  return value > 0 ? (
    <Ratio ratio={value}>
      <RatioContent>
        {children}
      </RatioContent>
    </Ratio>
  ) : children;
};

FixedRatio.propTypes = {
  value: PropTypes.number.isRequired
};

FixedRatio.defaultProps = {
  value: 0
};

export default FixedRatio;



// WEBPACK FOOTER //
// ./src/elements/util/FixedRatio/FixedRatio.jsx